module.exports = __webpack_public_path__ + "static/media/id-badge.cfa68af7.svg";